// Simplified Chinese locale
export default {
    app: {
        name: 'ActivityWatch',
        researchEdition: 'Research Edition',
    },
    nav: {
        activity: '活动',
        loading: '加载中...',
        noActivityReports: '暂无活动报告，请确认 AFK watcher 和 window watcher 都在运行。',
        timeline: '时间线',
        stopwatch: '秒表',
        tools: '工具',
        search: '搜索',
        workReport: '工作报告',
        trends: '趋势',
        report: '报告',
        alerts: '提醒',
        timespiral: '时间螺旋',
        query: '查询',
        graph: '图谱',
        rawData: '原始数据',
        settings: '设置',
    },
    footer: {
        madeWith: '由',
        byDevs: 'ActivityWatch 开发者制作',
        host: '主机：',
        version: '版本：',
        reportBug: '报告问题',
        askHelp: '寻求帮助',
        voteFeatures: '为功能投票',
        twitter: 'Twitter',
        github: 'GitHub',
        reddit: 'Reddit',
        donate: '捐赠',
    },
    common: {
        loading: '加载中...',
        save: '保存',
        cancel: '取消',
        confirm: '确认',
        import: '导入',
        export: '导出',
        open: '打开',
        more: '更多',
        delete: '删除',
        enabled: '已启用',
        disabled: '已停用',
        home: '首页',
        language: '语言',
        languageUk: 'Українська',
        languageEn: 'English',
        languageDe: 'Deutsch',
        languageRu: 'Русский',
        languageSv: 'Svenska',
        languageZhCN: '简体中文',
        rangeTo: '至',
    },
    notFound: {
        title: '页面未找到！',
        hint: '请尝试返回之前所在的页面。',
    },
    settings: {
        title: '设置',
        unsavedCategoriesLeave: '分类有未保存的更改，确定要离开吗？',
        daystart: {
            startOfDay: '每日开始时间',
            startOfDayHelp: '一天从这个时间开始，因为人们并不总是在午夜前睡觉。默认设置为 04:00。',
            startOfWeek: '每周开始日',
            startOfWeekHelp: '新一周从哪一天开始。',
            saturday: '星期六',
            sunday: '星期日',
            monday: '星期一',
        },
        theme: {
            title: '主题',
            auto: '跟随系统',
            light: '浅色',
            dark: '深色',
            help: '切换颜色主题。分类颜色会单独选择；切换到深色模式时可能需要调整它们。',
        },
        landingPage: {
            title: '打开页面',
            home: '首页',
            activity: '活动（{hostname}）',
            timeline: '时间线',
            help: '打开 ActivityWatch 或点击顶部菜单 logo 时进入的页面。',
        },
        language: {
            title: '语言',
            help: '选择 ActivityWatch 的界面显示语言。',
        },
        timelineDuration: {
            title: '默认时长',
            help: '时间线视图中“显示最近”默认使用的时长。',
        },
        releaseNotification: {
            title: '新版本通知',
            help: '启用后，Web UI 每天最多检查一次 ActivityWatch 新版本，并在有可用版本时显示提示。',
        },
        color: {
            title: '使用备用颜色',
            help: '在未分类或没有分类颜色时，部分可视化使用旧的着色方式。',
        },
        activePattern: {
            title: '始终计为活跃的模式',
            help1: '匹配此正则表达式的应用或标题永远不会被计为 AFK。',
            help2: '可用于在没有输入时仍将时间计为活跃，例如会议或使用手柄的游戏。留空表示停用。',
            example: '示例表达式：',
            invalid: '模式无效',
            tooBroad: '模式过宽',
        },
        categorization: {
            title: '分类',
            restoreDefaults: '恢复默认值',
            rulesHelp: '用于给事件分类的规则。一个事件只能属于一个分类。如果多个分类匹配，将选择最深层的分类。',
            builderIntro: '你可以使用',
            categoryBuilder: '分类构建器',
            builderOutro: '从未分类活动中快速创建分类。',
            forumIntro: '你也可以在这里查找和分享分类规则预设：',
            forum: '论坛',
            docsIntro: '如需了解如何编写分类规则，请参阅',
            documentation: '文档',
            categorySet: '分类集：',
            newSet: '新建分类集',
            deleteSet: '删除分类集',
            setsAvailable: '有 {count} 个分类集可用 — 切换分类集以使用不同的规则配置。',
            unsavedChanges: '你有未保存的更改！',
            discard: '放弃',
            addCategory: '添加分类',
            categories: '分类',
            priority: '优先级',
            priorityDefault: '默认',
            priorityInteger: '优先级必须是整数。',
            builderTitle: '分类构建器',
            builderSubtitle: '从未分类活动生成规则',
            openBuilder: '打开构建器',
            hideBuilder: '隐藏构建器',
        },
        developer: {
            title: '开发者设置',
            note: '注意：',
            noteBody: '这些设置面向知道自己在做什么的开发者，可能会意外破坏功能。',
            forceDevmode: '强制开发模式',
            forceDevmodeHelp: '开发模式会启用一些仍在开发中的功能。',
            requestTimeout: '请求超时时间',
            requestTimeoutHelp: '服务器请求超时前允许等待的最长时间。较高的值可用于大型查询。注意：需要重新加载 Web UI 后才会生效。',
            commitHash: 'Web UI 提交哈希：',
        },
        groups: {
            general: '常规',
            generalHelp: '影响时间范围、时间线和打开页面的默认设置。',
            appearance: '外观',
            appearanceHelp: '主题和可视化颜色。',
            categorization: '分类',
            categorizationHelp: '将事件归入分类的规则，以及离开/活跃模式覆盖设置。',
            privacy: '隐私',
            privacyHelp: '在数据存储前丢弃或脱敏敏感事件数据的过滤器。',
            developer: '开发者',
        },
    },
    home: {
        note: '注意：',
        androidNote: 'ActivityWatch Android 版仍在积极开发中。此处展示的电脑使用数据完全独立于你的 Android 设备。',
        greeting: '欢迎使用 ActivityWatch',
        intro1: '我们已经走了很远{android}，但仍然需要用户（比如你！）提供反馈，帮助我们把 ActivityWatch 做成一个成功的项目。我们很想听听你的改进想法。',
        introAndroid: '（尤其是在 Android 上！）',
        intro3: '如果你是开发者，我们希望你能编写 watcher、可视化或其他东西，并在论坛上分享给我们！',
        thanks: '感谢你使用 ActivityWatch！',
        surveyFill: '填写我们的用户调查',
        surveySuffix: '来帮助决定接下来要做什么。',
        surveyOr: '或',
        voteForum: '在论坛上为功能投票',
        spreadTitle: '传播出去',
        spread1: '没有什么比让 ActivityWatch 被更多用户使用更能激励我们。分享它会让我们把 ActivityWatch 做得更好！',
        spreadReview: '给我们点赞并评价：',
        spreadVote: '为我们投票：',
        spreadFollow: '关注我们并传播：',
        spreadStar: '给我们加星：',
        supportTitle: '支持我们！',
        subscribeIntro: 'The best way to keep ActivityWatch maintained is a subscription — from $5/month, every feature stays free, cancel anytime.',
        subscribeCta: 'Support ActivityWatch →',
        support1: '你喜欢 ActivityWatch 吗？它帮到你了吗？通过捐赠帮助我们继续帮助你！你可以通过以下方式捐赠：',
        support2: '更多信息请访问',
        donationPage: '网站上的捐赠页面',
        otherDonationMethods: '其他方式（包括加密货币）',
        resourcesTitle: '资源',
        website: '网站',
        documentation: '文档',
        forum: '论坛',
        discord: 'Discord',
        reddit: 'Reddit',
        apiBrowser: 'API 浏览器',
        workingOnTitle: '我们的工作进展',
        workingOnPrefix: '关注',
        devUpdates: '开发动态',
        workingOnMiddle: '了解最新进展，在',
        workingOnSuffix: '上关注项目获取发布说明。',
        landingHint: '你可以在',
        supporterNudge: {
            message: "You've been getting a lot out of ActivityWatch — would you consider supporting its development?",
            support: 'Support ActivityWatch →',
            notNow: 'Not now',
        },
    },
    buckets: {
        title: '存储桶',
        moreWatchers: '想要收集更多数据？查看',
        docsLink: '文档',
        thisDevice: '此设备',
        lastUpdatedInline: '最后更新',
        noEventsYet: '暂无记录的事件',
        noEvents: '无事件',
        moreActionsFor: '{hostname} 的更多操作',
        deleteAllTitle: '删除 {hostname} 的所有 {count} 个存储桶',
        deleteAllForHost: '删除此主机的所有存储桶',
        openBucket: '打开存储桶',
        deleteBucketTitle: '删除存储桶？',
        deleteHostTitle: '删除存储桶？',
        deleteHostTitleNamed: '删除 {hostname} 的所有存储桶？',
        deleteHostConfirmPrefix: '确定要删除',
        deleteHostConfirmCount: '所有 {count} 个存储桶',
        deleteHostConfirmSuffix: '的主机 "{hostname}"？',
        bucketsToDelete: '将被删除的存储桶：',
        deleting: '删除中...',
        importing: '导入中...',
        importHelpNew: '请提供从单个或多个存储桶导出的 JSON 文件。',
        exportHelp: '将此服务器上的每个存储桶下载为单个 JSON 文件。',
        currentDevice: '（当前设备）',
        lastUpdated: '最后更新：',
        firstSeen: '首次出现：',
        bucketId: '存储桶 ID',
        updated: '已更新',
        exportBucketJson: '导出存储桶为 JSON',
        exportEventsCsv: '导出事件为 CSV',
        deleteBucket: '删除存储桶',
        deleteModalTitle: '危险操作！',
        deleteConfirm: '确定要删除存储桶 "{id}" 吗？',
        deletePermanent: '此操作不可撤销！',
        importExportTitle: '导入和导出存储桶',
        importBuckets: '导入存储桶',
        importPlaceholder: '在此选择或拖放文件...',
        importDrop: '在此拖放文件...',
        importHelp: '有效的导入文件是从单个或多个存储桶导出的 JSON 文件。',
        exportBuckets: '导出存储桶',
        exportAllJson: '导出所有存储桶为 JSON',
        tools: '工具',
    },
    activity: {
        title: '活动',
        browserAllowlistMiss: '此时间段内未找到匹配的浏览器窗口。如果您使用的是 Chromium/Firefox 衍生浏览器，其应用名称可能尚未被识别。',
        for: '查看',
        host: '主机：',
        devices: '设备：',
        allDevices: '所有设备',
        allDevicesCount: '所有设备（{count}）',
        onlyThisDevice: '仅此',
        multideviceNote: '仅在查看单个设备时显示浏览器和秒表数据。',
        timeActive: '活跃时间：',
        queryRange: '查询范围：',
        filters: '筛选',
        filtersTitle: '筛选',
        refresh: '刷新',
        excludeAfk: '排除 AFK 时间',
        audibleActive: '将有声音的浏览器标签页计为活跃',
        includeStopwatch: '包含手动记录的事件（秒表）',
        newView: '新建视图',
        loadDemo: '加载演示数据',
        periodDay: '天',
        periodWeek: '周',
        periodMonth: '月',
        periodYear: '年',
        periodLast7d: '最近 7 天',
        periodLast30d: '最近 30 天',
        periodLast7dTitle: '最近 7 天',
        periodLast30dTitle: '最近 30 天',
        periodCustomRange: '自定义范围',
        rangeStart: '开始日期',
        rangeEnd: '结束日期',
        invalidRange: 'URL 中的日期范围无效，改为显示今天。',
        periodAllTime: '全部时间',
        allTimeSlowHint: '数据库较大时，加载全部时间可能需要一段时间。',
        filterAfkTooltip: '过滤掉 AFK watcher 未检测到任何输入的时间。',
        filterAudibleTooltip: '如果活动窗口是有声音的浏览器标签页，则计为活跃。需要浏览器 watcher。',
        showCategory: '显示分类',
        newViewTitle: '新建视图',
        viewId: 'ID',
        viewName: '名称',
        stopwatchWipNote: '注意：开发中。秒表事件在重叠时会遮蔽其他事件。',
        invalidForm: '表单输入无效：{errors}',
        errIdNotUnique: 'ID 不唯一',
        errMissingId: '缺少 ID',
        errMissingName: '缺少名称',
    },
    activityView: {
        addVisualization: '添加可视化',
        cancel: '取消',
        save: '保存',
        restoreDefaults: '恢复默认',
        remove: '移除',
        editView: '编辑视图',
        restoreAlert: '所有视图已恢复为默认设置。在点击保存之前不会保存更改。',
        removeViewTitle: '移除该视图？',
        removeViewOk: '移除视图',
        removeViewConfirm: '确定要移除',
        removeViewHint: '这将删除视图的配置。你可以运行',
        removeViewRestoreHint: '来恢复内置视图。',
        promptWatcher: '请输入 watcher 名称',
        promptTitle: '请输入可视化标题',
    },
    uncategorized: {
        title: '未分类时间过多',
        body: '你共有 {duration} 的未分类时间，占 {period} 总时间的 {percent}%。',
        hint: '你可以使用',
        categoryBuilder: '分类构建器',
        settingsCogTitle: '在设置中隐藏或调整此提示',
        periodToday: '今天',
        periodThisWeek: '本周',
        periodThisMonth: '本月',
        periodThisYear: '今年',
        periodLast7d: '最近 7 天',
        periodLast30d: '最近 30 天',
        periodCustomRange: '在所选范围内',
        periodAllTime: '总计',
    },
    visualizations: {
        noData: '（无数据）',
        unsupportedPeriod: '此功能不支持当前时间段。',
        missingWatcher: '此功能缺少所需 watcher 的数据。',
        docLink: '文档',
        allCategories: '全部',
        topApps: '常用应用',
        topTitles: '常用窗口标题',
        topDomains: '常用浏览器域名',
        topUrls: '常用浏览器 URL',
        topBrowserTitles: '常用浏览器标题',
        topEditorFiles: '常用编辑器文件',
        topEditorLanguages: '常用编辑器语言',
        topEditorProjects: '常用编辑器项目',
        topCategories: '常用分类',
        categoryTree: '分类树',
        categorySunburst: '分类旭日图',
        timelineBarchart: '时间线（条形图）',
        sunburstClock: '旭日时钟',
        dailyTimeline: '每日时间线（按时间顺序）',
        customVis: '自定义可视化',
        score: '得分',
        topStopwatches: '常用秒表事件',
        topBucketData: '常用存储桶数据',
    },
    timeline: {
        title: '时间线',
        eventsShown: '显示事件：',
        swimlanes: '泳道：',
        filterAfk: '过滤 AFK',
        mergeByApp: '按应用合并',
        noEvents: '没有符合筛选条件的事件。未更新时间线。',
        scrollHint: '滚动缩放，滑动/水平滚动平移，方向键导航',
        loading: '加载中...',
    },
    stopwatch: {
        title: '秒表',
        usingBucket: '使用存储桶：',
        aboutTitle: '关于秒表',
        aboutBody: '在自动追踪的同时手动记录会话。',
        placeholder: '你在做什么？',
        noRunning: '没有正在运行的秒表。在上面开始一个来追踪专注的工作。',
        start: '开始',
        running: '运行中',
        history: '历史记录',
    },
    search: {
        title: '搜索',
        earlyDev: '此功能仍在早期开发阶段。',
        searchBtn: '搜索',
        options: '选项',
        notFound: '没有找到想要的内容？',
        addWeek: '在搜索中增加一周：',
        addWeekBtn: '+1 周',
    },
    query: {
        title: '查询浏览器',
        docsHelp: '查看文档了解如何编写查询。',
        start: '开始',
        end: '结束',
    },
    workReport: {
        title: '工作时间报告',
        loading: '加载中...',
    },
    report: {
        title: '报告',
        description: '生成某个设备活动类别的使用时间报告。',
        earlyDev: '此功能仍在早期开发阶段。',
        generate: '生成',
        options: '选项',
        foundEvents: '在 {seconds} 秒内找到 {count} 个事件',
        csv: 'CSV',
    },
    trends: {
        titlePrefix: '趋势：',
        earlyDev: '此功能仍在早期开发阶段。',
        loadDemo: '加载演示数据',
    },
    timespiral: {
        title: '时间螺旋',
        wip: '这是一个正在开发中的实验功能。',
        noAfkBucket: '此主机上未找到 AFK 存储桶。请安装',
        noAfkBucketSuffix: '以使用时间螺旋。',
        bucketLabel: '存储桶：',
        eventsLabel: '事件：',
    },
};
